import { motion } from 'framer-motion';
// import './styles.scss';
import '../../pages/landingPage/sections/get_tasty_shawama_within_minutes/styles.scss';
const CircleSvg = () => {
  return (
    <svg
      width='350'
      height='350'
      viewBox='0 0 408 392'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='halve_circles'
    >
      <path
        d='M398.892 106.245C383.305 69.6989 357 38.5499 323.337 16.7757C322.485 16.2243 322.237 15.0841 322.794 14.2348V14.2348C323.338 13.4032 324.451 13.1628 325.286 13.7023C359.593 35.8725 386.401 67.6027 402.283 104.835C402.684 105.775 402.229 106.859 401.281 107.241V107.241C400.347 107.616 399.287 107.17 398.892 106.245Z'
        stroke='#EFE5E2'
        stroke-width='10'
      />
      <path
        d='M162.884 376.887C209.13 388.238 257.967 383.196 300.809 362.645C301.705 362.215 302.784 362.575 303.233 363.461V363.461C303.691 364.364 303.322 365.469 302.409 365.906C258.791 386.825 209.072 391.957 161.99 380.4C161.012 380.16 160.425 379.163 160.681 378.189V378.189C160.935 377.227 161.918 376.65 162.884 376.887Z'
        stroke='#EC5C34'
        stroke-width='10'
      />
      <path
        d='M34.4229 79.8458C53.0364 48.9645 79.6349 23.4998 111.497 6.03531C112.368 5.55759 113.46 5.87852 113.943 6.7476V6.7476C114.434 7.63381 114.105 8.75054 113.217 9.23804C81.9548 26.3899 55.8567 51.3854 37.5892 81.6926C19.3253 111.994 9.55251 146.504 9.2489 181.708C9.24014 182.724 8.4176 183.549 7.40109 183.55V183.55C6.38461 183.551 5.55909 182.727 5.56769 181.711C5.8709 145.856 15.8216 110.707 34.4229 79.8458Z'
        stroke='#34AC46'
        stroke-width='10'
      />
    </svg>
  );
};

export default CircleSvg;
